export default {
    methods: {
        stringToDate(x) {
            let ret = new Date(x);
            if (!x.includes('+'))
                ret = new Date(x + '+0000');
            if (!isFinite(ret.valueOf()))
                ret = new Date(x + 'T00:00+0000');
            return ret;
        },
        dateToString(date) {
            if (!date) return null;

            return date.getUTCFullYear() + '-' +
                (date.getUTCMonth() + 1).toString().padStart(2, '0') + '-' +
                date.getUTCDate().toString().padStart(2, '0')
        },
        dateTimeToString(date) {
            if (!date) return null;

            var ret = date.getUTCFullYear() + '-' +
                (date.getUTCMonth() + 1).toString().padStart(2, '0') + '-' +
                date.getUTCDate().toString().padStart(2, '0') + 'T' +
                date.getUTCHours().toString().padStart(2, '0') + ':' +
                date.getUTCMinutes().toString().padStart(2, '0') + ':' +
                date.getUTCSeconds().toString().padStart(2, '0')
            return ret;
        },
        dateMonthToString(date) {
            return (new Date()).getUTCFullYear() + '-' + ((new Date()).getUTCMonth() + 1).toString().padStart(2, '0');
        },
        formatDate(date) {
            if (!date) return null;
            if (typeof (date) == 'string') {
                date = this.stringToDate(date.substring(0, 10) + 'T00:00:00+0000');
            }
            return date.getUTCDate().toString().padStart(2, '0') + '.' +
                (date.getUTCMonth() + 1).toString().padStart(2, '0') + '.' +
                date.getUTCFullYear()
        },
        formatTime(date) {
            if (!date) return null;
            if (typeof (date) == 'string') {
                date = this.stringToDate(date);
            }
            return date.getUTCHours().toString().padStart(2, '0') + ':' +
                date.getUTCMinutes().toString().padStart(2, '0') + ':' +
                date.getUTCSeconds().toString().padStart(2, '0')
        },
        formatTimeShort(date) {
            if (!date) return null;
            if (typeof (date) == 'string') {
                date = this.stringToDate(date);
            }
            return date.getUTCHours().toString().padStart(2, '0') + ':' +
                date.getUTCMinutes().toString().padStart(2, '0')
        },
        formatDateTime(date) {
            return this.formatDate(date) + ' ' + this.formatTime(date)
        },
        formatMinutes(value) {
            value = parseFloat(value ?? 0);
            if (value == 0) {
                return '-';
            } else {
                let ret = '';
                if (value < 0) {
                    ret = '-';
                    value = -value;
                }
                let min = Math.floor(value);
                let sek = Math.floor(value * 60) % 60;
                if (min > 0) {
                    ret += min + ' ' + this.$t('timechecker.min') + ' '
                }
                if (sek > 0) {
                    ret += sek + ' ' + this.$t('timechecker.sek')
                }
                return ret;
            }
        },
        formatHours(value) {
            value = parseFloat(value ?? 0);
            if (value == 0) {
                return '-';
            } else {
                let ret = '';
                if (value < 0) {
                    ret = '-';
                    value = -value;
                }
                let hrs = Math.floor(value);
                let min = Math.floor(value * 60) % 60;
                let sek = Math.floor(value * 3600) % 60;
                if (hrs < 10) {
                    hrs = `0${hrs}`
                }
                if (min < 10) {
                    min = `0${min}`
                }
                if (sek < 10) {
                    sek = `0${sek}`
                }
                return `${ret}${hrs}:${min}:${sek}`;
            }
        },
        addOneDay(input) {
            const copy= new Date(input);
            copy.setUTCDate(copy.getUTCDate()+1)
            return copy;
        }
    }
}
